export enum ResourceModalModes {
  VIEW = "view",
  EDIT = "edit",
  CREATE = "create",
}
